import { render, staticRenderFns } from "./MemberInfo.vue?vue&type=template&id=1b90d690&"
import script from "./MemberInfo.vue?vue&type=script&lang=js&"
export * from "./MemberInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports